/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AwardSubscribeRequestDto } from '../models';
// @ts-ignore
import type { BonusRangeDto } from '../models';
// @ts-ignore
import type { CreateOrderRequestDto } from '../models';
// @ts-ignore
import type { CreateOrderResponseDto } from '../models';
// @ts-ignore
import type { PaymentSubscribeRequestDto } from '../models';
/**
 * PAYMENTApi - axios parameter creator
 * @export
 */
export const PAYMENTApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создание заказ
         * @param {CreateOrderRequestDto} createOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerCreateOrder: async (createOrderRequestDto: CreateOrderRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderRequestDto' is not null or undefined
            assertParamExists('paymentControllerCreateOrder', 'createOrderRequestDto', createOrderRequestDto)
            const localVarPath = `/payment/createOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение скидок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerGetBonusRange: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/getBonusRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Пополнение баланса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentBalance: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/paymentBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Новая покупка подписки
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentRate: async (type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('paymentControllerPaymentRate', 'type', type)
            const localVarPath = `/payment/paymentRate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Покупка подписки
         * @param {PaymentSubscribeRequestDto} paymentSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentSubscribe: async (paymentSubscribeRequestDto: PaymentSubscribeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentSubscribeRequestDto' is not null or undefined
            assertParamExists('paymentControllerPaymentSubscribe', 'paymentSubscribeRequestDto', paymentSubscribeRequestDto)
            const localVarPath = `/payment/paymentSubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentSubscribeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Админ: формирование счёта на оплату подписки для клиента
         * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentSubscribeByUserId: async (awardSubscribeRequestDto: AwardSubscribeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'awardSubscribeRequestDto' is not null or undefined
            assertParamExists('paymentControllerPaymentSubscribeByUserId', 'awardSubscribeRequestDto', awardSubscribeRequestDto)
            const localVarPath = `/payment/paymentSubscribeByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(awardSubscribeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Тестовая покупка подписки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentSubscribeTest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/paymentSubscribeTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PAYMENTApi - functional programming interface
 * @export
 */
export const PAYMENTApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PAYMENTApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создание заказ
         * @param {CreateOrderRequestDto} createOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerCreateOrder(createOrderRequestDto: CreateOrderRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerCreateOrder(createOrderRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerCreateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение скидок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerGetBonusRange(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BonusRangeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerGetBonusRange(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerGetBonusRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Пополнение баланса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerPaymentBalance(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerPaymentBalance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerPaymentBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Новая покупка подписки
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerPaymentRate(type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerPaymentRate(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerPaymentRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Покупка подписки
         * @param {PaymentSubscribeRequestDto} paymentSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerPaymentSubscribe(paymentSubscribeRequestDto: PaymentSubscribeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerPaymentSubscribe(paymentSubscribeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerPaymentSubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Админ: формирование счёта на оплату подписки для клиента
         * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerPaymentSubscribeByUserId(awardSubscribeRequestDto: AwardSubscribeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerPaymentSubscribeByUserId(awardSubscribeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerPaymentSubscribeByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Тестовая покупка подписки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentControllerPaymentSubscribeTest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentControllerPaymentSubscribeTest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PAYMENTApi.paymentControllerPaymentSubscribeTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PAYMENTApi - factory interface
 * @export
 */
export const PAYMENTApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PAYMENTApiFp(configuration)
    return {
        /**
         * 
         * @summary Создание заказ
         * @param {CreateOrderRequestDto} createOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerCreateOrder(createOrderRequestDto: CreateOrderRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponseDto> {
            return localVarFp.paymentControllerCreateOrder(createOrderRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение скидок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerGetBonusRange(options?: RawAxiosRequestConfig): AxiosPromise<Array<BonusRangeDto>> {
            return localVarFp.paymentControllerGetBonusRange(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Пополнение баланса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentBalance(options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponseDto> {
            return localVarFp.paymentControllerPaymentBalance(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Новая покупка подписки
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentRate(type: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentControllerPaymentRate(type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Покупка подписки
         * @param {PaymentSubscribeRequestDto} paymentSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentSubscribe(paymentSubscribeRequestDto: PaymentSubscribeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponseDto> {
            return localVarFp.paymentControllerPaymentSubscribe(paymentSubscribeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Админ: формирование счёта на оплату подписки для клиента
         * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentSubscribeByUserId(awardSubscribeRequestDto: AwardSubscribeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponseDto> {
            return localVarFp.paymentControllerPaymentSubscribeByUserId(awardSubscribeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Тестовая покупка подписки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentControllerPaymentSubscribeTest(options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponseDto> {
            return localVarFp.paymentControllerPaymentSubscribeTest(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PAYMENTApi - object-oriented interface
 * @export
 * @class PAYMENTApi
 * @extends {BaseAPI}
 */
export class PAYMENTApi extends BaseAPI {
    /**
     * 
     * @summary Создание заказ
     * @param {CreateOrderRequestDto} createOrderRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerCreateOrder(createOrderRequestDto: CreateOrderRequestDto, options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerCreateOrder(createOrderRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение скидок
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerGetBonusRange(options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerGetBonusRange(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Пополнение баланса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerPaymentBalance(options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerPaymentBalance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Новая покупка подписки
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerPaymentRate(type: string, options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerPaymentRate(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Покупка подписки
     * @param {PaymentSubscribeRequestDto} paymentSubscribeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerPaymentSubscribe(paymentSubscribeRequestDto: PaymentSubscribeRequestDto, options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerPaymentSubscribe(paymentSubscribeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Админ: формирование счёта на оплату подписки для клиента
     * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerPaymentSubscribeByUserId(awardSubscribeRequestDto: AwardSubscribeRequestDto, options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerPaymentSubscribeByUserId(awardSubscribeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Тестовая покупка подписки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PAYMENTApi
     */
    public paymentControllerPaymentSubscribeTest(options?: RawAxiosRequestConfig) {
        return PAYMENTApiFp(this.configuration).paymentControllerPaymentSubscribeTest(options).then((request) => request(this.axios, this.basePath));
    }
}

